import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowLeftFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowLeftFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M20.42 10.5H8.33L13.69 3h-3.68l-6.43 9 6.43 9h3.68l-5.35-7.5h12.08v-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowLeftFilled;